/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig = {
  auth: { //process.env.REACT_APP_HOST
    // clientId: "3819f81f-c65c-4738-878b-a4901f2b485e",
    // clientId: window.location.origin == 'https://calm-bush-052fefa03.1.azurestaticapps.net' ? "49ce927f-d7da-4caa-b8de-0306ca996ebb" : "97a5ca1d-d29f-4c79-b930-ed1aac04e529",
    clientId: process.env.REACT_APP_AGENT_PORTAL_AZURE_CLIENT_APP_ID,
    // authority: window.location.origin == 'https://calm-bush-052fefa03.1.azurestaticapps.net' ? "https://login.microsoftonline.com/ffea6392-44ee-4085-a734-3de7fd366620" : "https://login.microsoftonline.com/4029eaa5-ce94-4d28-81b9-5cac5e5cf88f",
    authority: process.env.REACT_APP_AGENT_PORTAL_AZURE_TENANT_ID,
    redirectUri: window.location.origin
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      }
    }
  }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  // scopes: ["User.Read","api://97a5ca1d-d29f-4c79-b930-ed1aac04e529/user_impersonation"]
  // scopes: window.location.origin == 'https://calm-bush-052fefa03.1.azurestaticapps.net' ? ["api://49ce927f-d7da-4caa-b8de-0306ca996ebb/user_impersonation"] : ["api://97a5ca1d-d29f-4c79-b930-ed1aac04e529/user_impersonation"]
  scopes: [process.env.REACT_APP_AGENT_PORTAL_AZURE_SCOPE]
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
  graphMeEndpoint: "Enter_the_Graph_Endpoint_Herev1.0/me"
};
